import { render, staticRenderFns } from "./ViewMail.vue?vue&type=template&id=7f3d5375&scoped=true&lang=pug&"
import script from "./ViewMail.vue?vue&type=script&lang=js&"
export * from "./ViewMail.vue?vue&type=script&lang=js&"
import style0 from "./ViewMail.vue?vue&type=style&index=0&id=7f3d5375&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d5375",
  null
  
)

export default component.exports